import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addPlanzoneResourcesToProject(
    request: Boundaries["addPlanzoneResourcesToProject"]["request"],
  ): void;
}

function useAddPlanzoneResourcesToProject(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isAddPlanzoneResourcesToProjectRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isAddPlanzoneResourcesToProjectRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isAddPlanzoneResourcesToProjectRequestFailure,
    ),
    addPlanzoneResourcesToProject: core.addPlanzoneResourcesToProject,
  };
}

export { useAddPlanzoneResourcesToProject };
